export const URL_CPC_PROFILE = "/.rest/cpc/v2/deeplink/profile";